// ============================================================================
// TEXTURE MANAGER
// Abstraction layer for rendering entities
// Currently: Procedurally generates textures
// Future: Can be swapped to load PNG/SVG textures without changing entity code
// ============================================================================

import CONFIG from '../config.js';

export class TextureManager {
    constructor() {
        // Future: Cache for loaded textures
        // this.textures = new Map();
    }

    /**
     * Draw a cupboard entity
     * @param {CanvasRenderingContext2D} ctx - Canvas context
     * @param {Object} cupboard - Cupboard entity instance
     * @param {Camera} camera - Camera for coordinate transformation
     */
    drawCupboard(ctx, cupboard, camera) {
        // This is the current procedural drawing logic
        // Later: Can be replaced with texture loading/drawing
        cupboard.draw(ctx, camera);
    }

    /**
     * Draw a wardrobe entity
     */
    drawWardrobe(ctx, wardrobe, camera) {
        wardrobe.draw(ctx, camera);
    }

    /**
     * Draw a chest entity
     */
    drawChest(ctx, chest, camera) {
        chest.draw(ctx, camera);
    }

    /**
     * Draw a door entity
     */
    drawDoor(ctx, door, camera) {
        door.draw(ctx, camera);
    }

    /**
     * Draw a bed entity
     */
    drawBed(ctx, bed, camera) {
        bed.draw(ctx, camera);
    }

    /**
     * Draw a desk entity
     */
    drawDesk(ctx, desk, camera) {
        desk.draw(ctx, camera);
    }

    /**
     * Draw a chair entity
     */
    drawChair(ctx, chair, camera) {
        chair.draw(ctx, camera);
    }

    /**
     * Draw a tree entity
     */
    drawTree(ctx, tree, camera) {
        tree.draw(ctx, camera);
    }

    /**
     * Draw an alarm clock entity
     */
    drawAlarmClock(ctx, alarmClock, camera) {
        alarmClock.draw(ctx, camera);
    }

    /**
     * Draw a player entity
     */
    drawPlayer(ctx, player, camera) {
        player.draw(ctx, camera);
    }

    /**
     * Draw a detached door (throwable)
     */
    drawDetachedDoor(ctx, detachedDoor, camera) {
        detachedDoor.draw(ctx, camera);
    }

    /**
     * Draw a detached mirror piece (throwable)
     */
    drawDetachedMirrorPiece(ctx, mirrorPiece, camera) {
        mirrorPiece.draw(ctx, camera);
    }

    /**
     * Draw a broken clock (throwable)
     */
    drawBrokenClock(ctx, brokenClock, camera) {
        brokenClock.draw(ctx, camera);
    }

    /**
     * Draw a detached clock hand (throwable)
     */
    drawDetachedClockHand(ctx, clockHand, camera) {
        clockHand.draw(ctx, camera);
    }

    /**
     * Generic draw method - routes to specific entity drawer
     * @param {CanvasRenderingContext2D} ctx - Canvas context
     * @param {string} entityType - Type of entity ('cupboard', 'wardrobe', 'detachedDoor', etc.)
     * @param {Object} entity - Entity instance
     * @param {Camera} camera - Camera for coordinate transformation
     */
    draw(ctx, entityType, entity, camera) {
        // Convert entityType to camelCase method name
        // e.g., 'detachedDoor' -> 'drawDetachedDoor', 'alarmClock' -> 'drawAlarmClock'
        const parts = entityType.split(/(?=[A-Z])/); // Split on capital letters
        const methodName = 'draw' + parts.map(part => 
            part.charAt(0).toUpperCase() + part.slice(1)
        ).join('');
        
        if (this[methodName] && typeof this[methodName] === 'function') {
            this[methodName](ctx, entity, camera);
        } else {
            // Fallback: try to call entity's own draw method
            if (entity && typeof entity.draw === 'function') {
                entity.draw(ctx, camera);
            } else {
                console.warn(`TextureManager: No draw method found for entity type "${entityType}"`);
            }
        }
    }

    // Future methods for texture loading:
    // async loadTexture(name, path) { ... }
    // async preloadTextures(textureList) { ... }
    // getTexture(name) { ... }
}
